import DesignLibraryModalManager from "components/jiffy/react-design-library-modal/design-library-modal";

document.addEventListener("DOMContentLoaded", () => new DesignLibraryModalManager());
